export default function useCustomMessages(sendSocketMessage: any) {
  const placeBet = (
    amount: any,
    boundary: string,
    over_or_under: any,
    rake: string,
  ) => {
    sendSocketMessage(
      'bet',
      typeof amount === 'number' ? amount.toString() : amount,
      +boundary * 100,
      Number(over_or_under),
    )
  }

  return { placeBet }
}
